import * as React from 'react';

const Gr16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#0D5EAF",
    d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M1 5.223v1.11h2.222v2.223H1v1.11h14v-1.11H4.333V6.333h2.223v1.111H15v-1.11H6.556V5.221H15V5c0-.32-.075-.62-.208-.889H6.556v1.111H4.333V3h-1.11v2.223H1Zm14 5.555H1V11a2 2 0 0 0 .208.89h13.584A2 2 0 0 0 15 11v-.222Z"
  }
));
Gr16.Size = 16;
Gr16.Title = "Gr";

export { Gr16 as default };
